/**
 * Bản tiếng Anh của `#collab`. Mỗi chuỗi lấy từ thuộc tính `data-en` của CHÍNH node đó trong
 * `template.html` — không dịch mới.
 *
 * `Quick switch` là ngoại lệ: `<b>` của nó là phần tử DUY NHẤT trong bốn hàng tính năng KHÔNG có
 * `data-en`, tức thiết kế cố ý giữ nguyên chuỗi ở cả hai ngôn ngữ. Chỉ `label` (chuỗi cho screen
 * reader) là khác, vì nó không nằm trong thiết kế mà sinh ra từ quyết định vẽ U+2318 bằng icon.
 */
interface FeatureCopy {
  readonly icon: 'corner-down-right' | 'clock' | 'mic' | 'command';
  readonly term: string;
  readonly body: string;
  readonly shortcut?: {
    readonly icon: 'command';
    readonly label: string;
    readonly key: string;
  };
}

interface TopicCopy {
  readonly icon: 'corner-down-right' | 'mic';
  readonly name: string;
  readonly meta: string;
  readonly badge: {
    readonly kind: 'mention' | 'count' | 'live';
    readonly text: string;
  };
  readonly active?: boolean;
}

const features: readonly FeatureCopy[] = [
  {
    icon: 'corner-down-right',
    term: 'Threads',
    body: 'replies open in a side panel, never losing the main flow.',
  },
  {
    icon: 'clock',
    term: 'Scheduled messages',
    body: 'schedule, repeat, reschedule or send now.',
  },
  {
    icon: 'mic',
    term: 'Voice rooms',
    body: 'a topic can be a live room; see who is in it before you join.',
  },
  {
    icon: 'command',
    term: 'Quick switch',
    shortcut: { icon: 'command', label: 'Command key', key: 'K' },
    body: 'jump to any channel, person or topic from the keyboard.',
  },
];

const topics: readonly TopicCopy[] = [
  {
    icon: 'corner-down-right',
    name: 'go-no-go',
    meta: 'Ben N.: readiness at 86%…',
    badge: { kind: 'mention', text: '@2' },
    active: true,
  },
  {
    icon: 'corner-down-right',
    name: 'rollout-pipeline',
    meta: 'Atlas: stage deploy finished',
    badge: { kind: 'count', text: '5' },
  },
  {
    icon: 'mic',
    name: 'war-room',
    meta: '4 people in the room',
    badge: { kind: 'live', text: 'LIVE' },
  },
];

export const collab = {
  eyebrow: 'Chat & Topic',
  heading: 'A channel stays readable when every thread has its own room.',
  lead: 'Topics keep parallel conversations inside one channel without drowning it — each with separate unread and mention counts, so you always know where you are needed.',
  features,
  mock: {
    channel: 'q2-launch',
    topicCount: '3 topics',
    topics,
    scheduled: 'Scheduled — sends tomorrow at 09:00 to #q2-launch',
  },
};
